import { render, staticRenderFns } from "./MovementReport.vue?vue&type=template&id=79884bff&scoped=true"
import script from "./MovementReport.vue?vue&type=script&lang=js"
export * from "./MovementReport.vue?vue&type=script&lang=js"
import style0 from "./MovementReport.vue?vue&type=style&index=0&id=79884bff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79884bff",
  null
  
)

export default component.exports